import React from 'react';

// Terminal-Ausgabe mit stilisiertem Format
function TerminalOutput({ output }) {
  if (!output) return null;
  
  return (
    <div className="bg-black text-green-400 font-mono p-3 rounded mb-4 text-sm overflow-x-auto">
      {output}
    </div>
  );
}

export default TerminalOutput;
